import styled from "styled-components/macro";

export const SampleRequestResult = styled.div({});

export default null;
